import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { map, Observable, of } from "rxjs";
import { ContainerViewModel } from "app/system/admin-panel/ContainerViewModel";

@Injectable()
export class ContainersService {
  constructor(private client: HttpClient) {}

  public GetContainers(): Observable<ContainerViewModel[]> {
    return this.client.get<any>("/ctrl/Containers").pipe(map(values => {
      const result: ContainerViewModel[] = [];
      if (values && values.constructor === Array) {
        for (const item of values)
          result.push(ContainerViewModel.fromJS(item));
      }

      return result;
    }));
  }

  public GetContainersByUser(userId: number): Observable<ContainerViewModel[]> {
    return this.client.get<any>(`/ctrl/Containers/by-user/${userId}`).pipe(map(values => {
      const result: ContainerViewModel[] = [];
      if (values && values.constructor === Array) {
        for (const item of values)
          result.push(ContainerViewModel.fromJS(item));
      }

      return result;
    }));
  }

  public GetByCompanyId(companyId: number): Observable<ContainerViewModel[]> {
    if (!companyId || companyId <= 0) {
      return of([]);
    }

    return this.client.get<any>(`/ctrl/Containers/company/${companyId}`).pipe(map(values => {
      const result: ContainerViewModel[] = [];
      if (values && values.constructor === Array) {
        for (const item of values)
          result.push(ContainerViewModel.fromJS(item));
      }

      return result;
    }));
  }

  public GetContainer(id: number): Observable<ContainerViewModel> {
    return this.client.get<any>(`/ctrl/Containers/${id}`).pipe(map(data => {
      return ContainerViewModel.fromJS(data);
    }));
  }

  public CreateContainer(model: { Name: string; CompanyId: number; Users?: any[] }): Observable<ContainerViewModel> {
    return this.client.post<any>("/ctrl/Containers", model).pipe(map(data => ContainerViewModel.fromJS(data)));
  }

  public UpdateContainer(model: { Id: number; Name: string; CompanyId: number; Users?: any[] }): Observable<ContainerViewModel> {
    return this.client.put<any>("/ctrl/Containers", model).pipe(map(data => ContainerViewModel.fromJS(data)));
  }

  public DeleteContainer(id: number): Observable<any> {
    return this.client.delete(`/ctrl/Containers/${id}`);
  }
}
